// extracted by mini-css-extract-plugin
export default {"block":"Block_block__dVPmF","isActiveBlock":"Block_isActiveBlock__ExOpS","checkbox":"Block_checkbox__HltZV","icon":"Block_icon__6FaHY","text":"Block_text__Olw1W"};